export default __webpack_public_path__ + "static/media/Shape2.1fb622cb.svg";